import { z } from 'zod';
import { camelCaseToTitleCase } from './utils';
type ValidateConfig<T, TK extends keyof T> = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  conditions: (data: T, key: TK) => any;
  error: (name: string) => string;
  fieldName: string;
  path?: Array<string>;
};

export const toSetError =
  <TS>(data: TS, ctx: z.RefinementCtx) =>
  <T extends keyof TS>(
    field: T,
    config: Partial<ValidateConfig<TS, T>> = {},
  ) => {
    const path = String(field);

    const c: ValidateConfig<TS, T> = {
      error: (name: string) => `${name} is required`,
      fieldName: camelCaseToTitleCase(path),
      conditions: (data, field) => Boolean(data[field]) === false,
      path: config.path || [path],
      ...config,
    };

    if (Boolean(c.conditions(data, field)) === false) return false;
    const message = c.error(c.fieldName);
    ctx.addIssue({ code: z.ZodIssueCode.custom, path: c.path, message });

    return true;
  };
